import React, { useContext } from "react";
import { IntlProvider } from "react-intl";
import translations from "../translations";
import { LanguageContext } from "../contexts/languageContext";
import { IParentProps } from "../types";

const RouteWithIntl: React.FC<IParentProps> = ({ children }) => {
  const { language } = useContext<any>(LanguageContext);

  return (
    <IntlProvider locale={language} messages={translations[language]}>
      {children}
    </IntlProvider>
  );
};

export default RouteWithIntl;
